import { createAction } from 'redux-actions'
import { hideWarehouseSetup } from 'actions'

/**
 * Types.
 */

export const WAREHOUSE_SETUP_SELECT_DATABASE = 'WAREHOUSE_SETUP_SELECT_DATABASE'
export const WAREHOUSE_SETUP_SELECT_CONNECT_TAB =
  'WAREHOUSE_SETUP_SELECT_CONNECT_TAB'
export const WAREHOUSE_SETUP_CONNECT = 'WAREHOUSE_SETUP_CONNECT'
export const WAREHOUSE_SETUP_CONNECT_ERROR = 'WAREHOUSE_SETUP_CONNECT_ERROR'
export const WAREHOUSE_SETUP_CONNECTED = 'WAREHOUSE_SETUP_CONNECTED'
export const WAREHOUSE_SETUP_COMPLETED = 'WAREHOUSE_SETUP_COMPLETED'
export const WAREHOUSE_SETUP_CANCELED = 'WAREHOUSE_SETUP_CANCELED'
export const WAREHOUSE_SETUP_CHANGE_STEP = 'WAREHOUSE_SETUP_CHANGE_STEP'
export const CREATING_WAREHOUSE = 'CREATING_WAREHOUSE'
export const CREATE_WAREHOUSE_ERROR = 'CREATE_WAREHOUSE_ERROR'
export const CREATED_WAREHOUSE = 'CREATED_WAREHOUSE'

/**
 * Actions.
 */

export const warehouseSetupSelectDatabase = createAction(
  WAREHOUSE_SETUP_SELECT_DATABASE
)
export const warehouseSetupSelectConnectTab = createAction(
  WAREHOUSE_SETUP_SELECT_CONNECT_TAB
)
export const warehouseSetupCompleted = createAction(WAREHOUSE_SETUP_COMPLETED)
export const warehouseSetupChangeStep = createAction(
  WAREHOUSE_SETUP_CHANGE_STEP
)

export const creatingWarehouse = createAction(CREATING_WAREHOUSE)
export const createdWarehouse = createAction(CREATED_WAREHOUSE)
export const createWarehouseError = createAction(CREATE_WAREHOUSE_ERROR)

export const warehouseSetupConnecting = createAction(WAREHOUSE_SETUP_CONNECT)
const warehouseSetupCanceled = createAction(WAREHOUSE_SETUP_CANCELED)
export const warehouseSetupConnectError = createAction(
  WAREHOUSE_SETUP_CONNECT_ERROR
)
export const warehouseSetupConnected = createAction(WAREHOUSE_SETUP_CONNECTED)

export function cancelWarehouseSetup() {
  return dispatch => {
    dispatch(hideWarehouseSetup())
    dispatch(warehouseSetupCanceled())
  }
}
